// src/utils/constants.js

const constants = {
    // API URLs
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1',
    AUTH_API_URL: process.env.REACT_APP_AUTH_API_URL || 'http://localhost:3000/api/auth',

    // Other environment-specific variables
    NODE_ENV: process.env.NODE_ENV || 'development',
    APP_NAME: process.env.REACT_APP_NAME || 'My React App',

    // Feature flags
    ENABLE_FEATURE_X: process.env.REACT_APP_ENABLE_FEATURE_X === 'true',

    // Timeouts
    API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '5000', 10),

    // Add more constants as needed
};

export default constants;
